import { render, staticRenderFns } from "./CzCard.vue?vue&type=template&id=77271039&scoped=true&"
import script from "./CzCard.vue?vue&type=script&lang=ts&"
export * from "./CzCard.vue?vue&type=script&lang=ts&"
import style0 from "./CzCard.vue?vue&type=style&index=0&id=77271039&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77271039",
  null
  
)

export default component.exports